import React from 'react'

import clsx from 'clsx'

import Grid from 'components/Grid'

import Alternatives from './components/Alternatives'
import Main from './components/Main'
import Secondary from './components/Secondary'
import Separator from './components/Separator'
import Title from './components/Title'

import classes from './Section.module.scss'

const Section = ({ children }) => {
  return (
    <Grid className={clsx('Section', classes.root)} container>
      {children}
    </Grid>
  )
}

Section.Main = Main
Section.Alternatives = Alternatives
Section.Title = Title
Section.Secondary = Secondary
Section.Separator = Separator

export default Section
